// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import { combineReducers } from 'redux';
import { get } from '../../shared/http/request';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import values from 'lodash/values';
import update from 'immutability-helper';
import queryString from 'query-string';
import { handleApiError } from '../../shared/http/error';

/** ************************
 * Dashboard redux bundle *
 ************************* */
// API
const BASE_URL = '/api/dashboard';
const BASE_URL_REPORTS = '/api/reports';

// Actions
const LOAD_TODO_ABNORMALITIES_FULFILLED = 'LOAD_TODO_ABNORMALITIES_FULFILLED';
const LOAD_TODO_ABNORMALITIES_PENDING = 'LOAD_TODO_ABNORMALITIES_PENDING';
const LOAD_TODO_ABNORMALITIES_REJECTED = 'LOAD_TODO_ABNORMALITIES_REJECTED';
const LOAD_FOLLOWUP_ABNORMALITIES_FULFILLED = 'LOAD_FOLLOWUP_ABNORMALITIES_FULFILLED';
const LOAD_FOLLOWUP_ABNORMALITIES_PENDING = 'LOAD_FOLLOWUP_ABNORMALITIES_PENDING';
const LOAD_FOLLOWUP_ABNORMALITIES_REJECTED = 'LOAD_FOLLOWUP_ABNORMALITIES_REJECTED';
const LOAD_EMCS_PENDING = 'LOAD_EMCS_PENDING';
const LOAD_EMCS_FULFILLED = 'LOAD_EMCS_FULFILLED';
const LOAD_EMCS_REJECTED = 'LOAD_EMCS_REJECTED';
const LOAD_EMCS_PLANT_CODES_PENDING = 'LOAD_EMCS_PLANT_CODES_PENDING';
const LOAD_EMCS_PLANT_CODES_FULFILLED = 'LOAD_EMCS_PLANT_CODES_FULFILLED';
const LOAD_EMCS_PLANT_CODES_REJECTED = 'LOAD_EMCS_PLANT_CODES_REJECTED';
const LOAD_EMCS_DOCK_CODES_PENDING = 'LOAD_EMCS_DOCK_CODES_PENDING';
const LOAD_EMCS_DOCK_CODES_FULFILLED = 'LOAD_EMCS_DOCK_CODES_FULFILLED';
const LOAD_EMCS_DOCK_CODES_REJECTED = 'LOAD_EMCS_DOCK_CODES_REJECTED';
const LOAD_TODO_RECOVERY_ACTIONS_FULFILLED = 'LOAD_TODO_RECOVERY_ACTIONS_FULFILLED';
const LOAD_TODO_RECOVERY_ACTIONS_PENDING = 'LOAD_TODO_RECOVERY_ACTIONS_PENDING';
const LOAD_TODO_RECOVERY_ACTIONS_REJECTED = 'LOAD_TODO_RECOVERY_ACTIONS_REJECTED';
const LOAD_FOLLOWUP_RECOVERY_ACTIONS_FULFILLED = 'LOAD_FOLLOWUP_RECOVERY_ACTIONS_FULFILLED';
const LOAD_FOLLOWUP_RECOVERY_ACTIONS_PENDING = 'LOAD_FOLLOWUP_RECOVERY_ACTIONS_PENDING';
const LOAD_FOLLOWUP_RECOVERY_ACTIONS_REJECTED = 'LOAD_FOLLOWUP_RECOVERY_ACTIONS_REJECTED';
const LOAD_LOST_TRACKING_RUNS_PENDING = 'LOAD_LOST_TRACKING_RUNS_PENDING';
const LOAD_LOST_TRACKING_RUNS_FULFILLED = 'LOAD_LOST_TRACKING_RUNS_FULFILLED';
const LOAD_LOST_TRACKING_RUNS_REJECTED = 'LOAD_LOST_TRACKING_RUNS_REJECTED';

const LOAD_DELAYS_PENDING = 'LOAD_DELAYS_PENDING';
const LOAD_DELAYS_FULFILLED = 'LOAD_DELAYS_FULFILLED';
const LOAD_DELAYS_REJECTED = 'LOAD_DELAYS_REJECTED';

const STORE_SEARCH_TODO_ABNORMALITIES = 'STORE_SEARCH_TODO_ABNORMALITIES';
const STORE_SEARCH_FOLLOWUP_ABNORMALITIES = 'STORE_SEARCH_FOLLOWUP_ABNORMALITIES';
const STORE_SEARCH_TODO_RECOVERY_ACTIONS = 'STORE_SEARCH_TODO_RECOVERY_ACTIONS';
const STORE_SEARCH_FOLLOWUP_RECOVERY_ACTIONS = 'STORE_SEARCH_FOLLOWUP_RECOVERY_ACTIONS';
const STORE_SEARCH_DELAYS = 'STORE_SEARCH_DELAYS';

// Reducers
const entities = (
    state = {
        todoAbnormalities: {},
        followUpAbnormalities: {},
        emcs: [],
        plants: [],
        todoRecoveryActions: {},
        followUpRecoveryActions: {},
        delays: {},
        lostTrackingRuns: {},
    },
    action
) => {
    switch (action.type) {
        case LOAD_TODO_ABNORMALITIES_FULFILLED:
            const todoAbnormalitiesById = map(action.todoAbnormalities, abn => ({
                [abn.dashboardId]: abn,
            }));
            const todoAbnormalitiesObj = Object.assign({}, ...todoAbnormalitiesById);
            const tState = update(state, {
                todoAbnormalities: { $set: todoAbnormalitiesObj },
            });
            return tState;
        case LOAD_FOLLOWUP_ABNORMALITIES_FULFILLED:
            const followUpAbnormalitiesById = map(action.followUpAbnormalities, abn => ({
                [abn.dashboardId]: abn,
            }));
            const followUpAbnormalitiesObj = Object.assign({}, ...followUpAbnormalitiesById);
            const fState = update(state, {
                followUpAbnormalities: { $set: followUpAbnormalitiesObj },
            });
            return fState;
        case LOAD_EMCS_FULFILLED:
            const emcs = map(action.emcs, emc => ({ code: emc.code }));
            const eState = update(state, {
                emcs: { $set: sortBy(emcs, ['code']) },
            });
            return eState;
        case LOAD_EMCS_PLANT_CODES_FULFILLED:
            const plants = map(action.plants, plant => ({ code: plant.emcPlantCode }));
            const ePlantState = update(state, {
                plants: { $set: sortBy(plants, ['emcPlantCode']) },
            });
            return ePlantState;
        case LOAD_EMCS_DOCK_CODES_FULFILLED:
            const docks = map(action.docks, dock => ({ code: dock.emcDockCode }));
            const eDockState = update(state, {
                docks: { $set: sortBy(docks, ['emcDockCode']) },
            });
            return eDockState;
        case LOAD_TODO_RECOVERY_ACTIONS_FULFILLED:
            const todoRecoveryActionsById = map(action.todoRecoveryActions, rec => ({
                [rec.dashboardId]: rec,
            }));
            const todoRecoveryActionsObj = Object.assign({}, ...todoRecoveryActionsById);
            const trState = update(state, {
                todoRecoveryActions: { $set: todoRecoveryActionsObj },
            });
            return trState;
        case LOAD_FOLLOWUP_RECOVERY_ACTIONS_FULFILLED:
            const followUpRecoveryActionsById = map(action.followUpRecoveryActions, rec => ({
                [rec.dashboardId]: rec,
            }));
            const followUpRecoveryActionsObj = Object.assign({}, ...followUpRecoveryActionsById);
            const frState = update(state, {
                followUpRecoveryActions: { $set: followUpRecoveryActionsObj },
            });
            return frState;
        case LOAD_DELAYS_FULFILLED:
            const delaysById = map(action.delays, rec => ({
                [rec.dashboardId]: rec,
            }));
            const delaysObj = Object.assign({}, ...delaysById);
            const dState = update(state, { delays: { $set: delaysObj } });
            return dState;
        case LOAD_LOST_TRACKING_RUNS_FULFILLED:
            const runsById = map(action.lostTrackingRuns, rec => ({
                [rec.runId]: rec,
            }));
            const runsObj = Object.assign({}, ...runsById);
            const ltState = update(state, {
                lostTrackingRuns: { $set: runsObj },
            });
            return ltState;
        case LOAD_TODO_ABNORMALITIES_PENDING:
            return update(state, { todoAbnormalities: { $set: [] } });
        case LOAD_FOLLOWUP_ABNORMALITIES_PENDING:
            return update(state, { followUpAbnormalities: { $set: [] } });
        case LOAD_TODO_RECOVERY_ACTIONS_PENDING:
            return update(state, { todoRecoveryActions: { $set: [] } });
        case LOAD_FOLLOWUP_RECOVERY_ACTIONS_PENDING:
            return update(state, { followUpRecoveryActions: { $set: [] } });
        case LOAD_DELAYS_PENDING:
            return update(state, { delays: { $set: [] } });
        case LOAD_LOST_TRACKING_RUNS_PENDING:
            return update(state, { lostTrackingRuns: { $set: [] } });
        default:
            return state;
    }
};

const isTodoFetching = (state = false, action) => {
    switch (action.type) {
        case LOAD_TODO_ABNORMALITIES_PENDING:
        case LOAD_TODO_RECOVERY_ACTIONS_PENDING:
            return true;
        case LOAD_TODO_ABNORMALITIES_FULFILLED:
        case LOAD_TODO_ABNORMALITIES_REJECTED:
        case LOAD_TODO_RECOVERY_ACTIONS_FULFILLED:
        case LOAD_TODO_RECOVERY_ACTIONS_REJECTED:
            return false;
        default:
            return state;
    }
};

const isFollowUpFetching = (state = false, action) => {
    switch (action.type) {
        case LOAD_FOLLOWUP_ABNORMALITIES_PENDING:
        case LOAD_FOLLOWUP_RECOVERY_ACTIONS_PENDING:
            return true;
        case LOAD_FOLLOWUP_ABNORMALITIES_FULFILLED:
        case LOAD_FOLLOWUP_ABNORMALITIES_REJECTED:
        case LOAD_FOLLOWUP_RECOVERY_ACTIONS_FULFILLED:
        case LOAD_FOLLOWUP_RECOVERY_ACTIONS_REJECTED:
            return false;
        default:
            return state;
    }
};

const isLostTrackingRunsFetching = (state = false, action) => {
    switch (action.type) {
        case LOAD_LOST_TRACKING_RUNS_PENDING:
            return true;
        case LOAD_LOST_TRACKING_RUNS_FULFILLED:
        case LOAD_LOST_TRACKING_RUNS_REJECTED:
            return false;
        default:
            return state;
    }
};

const isDelaysFetching = (state = false, action) => {
    switch (action.type) {
        case LOAD_DELAYS_PENDING:
            return true;
        case LOAD_DELAYS_FULFILLED:
        case LOAD_DELAYS_REJECTED:
            return false;
        default:
            return state;
    }
};

const error = (state = null, action) => {
    switch (action.type) {
        case LOAD_TODO_ABNORMALITIES_REJECTED:
        case LOAD_FOLLOWUP_ABNORMALITIES_REJECTED:
        case LOAD_LOST_TRACKING_RUNS_REJECTED:
            return true;
        case LOAD_TODO_ABNORMALITIES_PENDING:
        case LOAD_TODO_ABNORMALITIES_FULFILLED:
        case LOAD_FOLLOWUP_ABNORMALITIES_PENDING:
        case LOAD_FOLLOWUP_ABNORMALITIES_FULFILLED:
        case LOAD_LOST_TRACKING_RUNS_FULFILLED:
        case LOAD_LOST_TRACKING_RUNS_PENDING:
            return false;
        default:
            return state;
    }
};

export const INITIAL_TODO_ABN_SEARCH_FORM = {
    abnormalityDate: '',
    abnormalityName: '',
    abnormalityStatus: '',
    abnormalityType: '',
    assignee: '',
    assigneeGroup: '',
    destination: '',
    location: '',
    routeCode: '',
    runDate: '',
    tlmsUpdate: '',
    excludePSSAndSS: '',
};
const searchTodoAbnormalities = (state = INITIAL_TODO_ABN_SEARCH_FORM, action) => {
    switch (action.type) {
        case STORE_SEARCH_TODO_ABNORMALITIES:
            return Object.assign({}, state, action.searchTodoAbnormalities);
        default:
            return state;
    }
};

export const INITIAL_FOLLOW_UP_ABN_SEARCH_FORM = {
    abnormalityDate: '',
    abnormalityName: '',
    abnormalityStatus: '',
    abnormalityType: '',
    assignee: '',
    assigneeGroup: '',
    destination: '',
    location: '',
    routeCode: '',
    runDate: '',
    tlmsUpdate: '',
    isOverdueRecoveryAction: '',
};
const searchFollowUpAbnormalities = (state = INITIAL_FOLLOW_UP_ABN_SEARCH_FORM, action) => {
    switch (action.type) {
        case STORE_SEARCH_FOLLOWUP_ABNORMALITIES:
            return Object.assign({}, state, action.searchFollowUpAbnormalities);
        default:
            return state;
    }
};

export const INITIAL_TODO_REC_ACTIONS_SEARCH = {
    abnormalityDate: '',
    abnormalityName: '',
    abnormalityStatus: '',
    abnormalityType: '',
    assignee: '',
    assigneeGroup: '',
    destination: '',
    location: '',
    routeCode: '',
    runDate: '',
    tlmsUpdate: '',
    isOverdueRecoveryAction: '',
};
const searchTodoRecoveryActions = (state = INITIAL_TODO_REC_ACTIONS_SEARCH, action) => {
    switch (action.type) {
        case STORE_SEARCH_TODO_RECOVERY_ACTIONS:
            return Object.assign({}, state, action.searchTodoRecoveryActions);
        default:
            return state;
    }
};

export const INITIAL_FOLLOW_UP_REC_ACTIONS_SEARCH = {
    abnormalityDate: '',
    abnormalityName: '',
    abnormalityStatus: '',
    abnormalityType: '',
    assignee: '',
    assigneeGroup: '',
    destination: '',
    location: '',
    routeCode: '',
    runDate: '',
    tlmsUpdate: '',
	excludePSSAndSS: '',
};
const searchFollowUpRecoveryActions = (state = INITIAL_FOLLOW_UP_REC_ACTIONS_SEARCH, action) => {
    switch (action.type) {
        case STORE_SEARCH_FOLLOWUP_RECOVERY_ACTIONS:
            return Object.assign({}, state, action.searchFollowUpRecoveryActions);
        default:
            return state;
    }
};

export const INITIAL_DELAY_SEARCH_FORM = {
    abnormalityDate: '',
    abnormalityStatus: '',
    assignee: '',
    assigneeGroup: '',
    delay: '',
    destination: '',
    name: '',
    routeCode: '',
    runDate: '',
    severity: '',
    tlmsUpdate: '',
};
const searchDelays = (state = INITIAL_DELAY_SEARCH_FORM, action) => {
    switch (action.type) {
        case STORE_SEARCH_DELAYS:
            return Object.assign({}, state, action.searchDelays);
        default:
            return state;
    }
};

export default combineReducers({
    entities,
    isTodoFetching,
    isFollowUpFetching,
    error,
    isLostTrackingRunsFetching,
    searchTodoAbnormalities,
    searchTodoRecoveryActions,
    isDelaysFetching,
    searchDelays,
    searchFollowUpRecoveryActions,
    searchFollowUpAbnormalities,
});

// Selectors
export const getTodoAbnormalities = state =>
    values(state.entities.dashboard.entities.todoAbnormalities);
export const getTodoRecoveryActions = state =>
    values(state.entities.dashboard.entities.todoRecoveryActions);
export const getFollowUpAbnormalities = state =>
    values(state.entities.dashboard.entities.followUpAbnormalities);
export const getFollowUpRecoveryActions = state =>
    values(state.entities.dashboard.entities.followUpRecoveryActions);
export const getEMCs = state => state.entities.dashboard.entities.emcs;
export const getEMCPlantCodes = state => state.entities.dashboard.entities.plants;
export const getEMCDockCodes = state => state.entities.dashboard.entities.docks;
export const getEMCDocks = state => state.entities.dashboard.entities.emcDocks;
export const getIsTodoFetching = state => state.entities.dashboard.isTodoFetching;
export const getIsFollowUpFetching = state => state.entities.dashboard.isFollowUpFetching;
export const getError = state => state.entities.dashboard.error;
export const getIsLostTrackingRunsFetching = state =>
    state.entities.dashboard.isLostTrackingRunsFetching;
export const getLostTrackingRuns = state =>
    values(state.entities.dashboard.entities.lostTrackingRuns);
export const getSearchTodoAbnormalities = state => state.entities.dashboard.searchTodoAbnormalities;
export const getSearchTodoRecoveryActions = state =>
    state.entities.dashboard.searchTodoRecoveryActions;
export const getDelays = state => values(state.entities.dashboard.entities.delays);
export const getIsDelayFetching = state => state.entities.dashboard.isDelaysFetching;
export const getDelaySearch = state => state.entities.dashboard.searchDelays;
export const getSearchFollowUpRecoveryActions = state =>
    state.entities.dashboard.searchFollowUpRecoveryActions;
export const getSearchFollowUpAbnormalities = state =>
    state.entities.dashboard.searchFollowUpAbnormalities;

// Action Creators/Thunks
export function loadTodoAbnormalities(params = null) {
    return function(dispatch) {
        let url = `${BASE_URL}/abnormality/todo/`;

        if (params) {
            const stringifiedParams = queryString.stringify(params);
            url += `?${stringifiedParams}&sortParam=abnormalityDate&sortDirection=desc`;
        }

        dispatch({ type: LOAD_TODO_ABNORMALITIES_PENDING });

        return get(url).then(
            response =>
                dispatch({
                    type: LOAD_TODO_ABNORMALITIES_FULFILLED,
                    todoAbnormalities: response.dashboardResources,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_TODO_ABNORMALITIES_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadFollowUpAbnormalities(params = null) {
    return function(dispatch) {
        let url = `${BASE_URL}/abnormality/follow-up/`;

        if (params) {
            const stringifiedParams = queryString.stringify(params);
            url += `?${stringifiedParams}&sortParam=abnormalityDate&sortDirection=desc`;
        }

        dispatch({ type: LOAD_FOLLOWUP_ABNORMALITIES_PENDING });

        return get(url).then(
            response =>
                dispatch({
                    type: LOAD_FOLLOWUP_ABNORMALITIES_FULFILLED,
                    followUpAbnormalities: response.dashboardResources,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_FOLLOWUP_ABNORMALITIES_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadTodoRecoveryActions(params = null) {
    return function(dispatch) {
        let url = `${BASE_URL}/recovery-action/todo/`;

        if (params) {
            const stringifiedParams = queryString.stringify(params);
            url += `?${stringifiedParams}&sortParam=abnormalityDate&sortDirection=desc`;
        }

        dispatch({ type: LOAD_TODO_RECOVERY_ACTIONS_PENDING });

        return get(url).then(
            response =>
                dispatch({
                    type: LOAD_TODO_RECOVERY_ACTIONS_FULFILLED,
                    todoRecoveryActions: response.dashboardResources,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_TODO_RECOVERY_ACTIONS_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadFollowUpRecoveryActions(params = null) {
    return function(dispatch) {
        let url = `${BASE_URL}/recovery-action/follow-up/`;

        if (params) {
            const stringifiedParams = queryString.stringify(params);
            url += `?${stringifiedParams}&sortParam=abnormalityDate&sortDirection=desc`;
        }

        dispatch({ type: LOAD_FOLLOWUP_RECOVERY_ACTIONS_PENDING });

        return get(url).then(
            response =>
                dispatch({
                    type: LOAD_FOLLOWUP_RECOVERY_ACTIONS_FULFILLED,
                    followUpRecoveryActions: response.dashboardResources,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_FOLLOWUP_RECOVERY_ACTIONS_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadLostTrackingRuns() {
    return function(dispatch) {
        let url = '/api/runs/lost?sortParam=runDate&sortDirection=asc';

        dispatch({ type: LOAD_LOST_TRACKING_RUNS_PENDING });

        return get(url).then(
            response =>
                dispatch({
                    type: LOAD_LOST_TRACKING_RUNS_FULFILLED,
                    lostTrackingRuns: response.runResources,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_LOST_TRACKING_RUNS_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadDelays(params = null) {
    return function(dispatch) {
        let url = `${BASE_URL}/delay/`;

        if (params) {
            const stringifiedParams = queryString.stringify(params);
            url += `?${stringifiedParams}&sortParam=severity&sortDirection=desc`;
        }

        dispatch({ type: LOAD_DELAYS_PENDING });
        return get(url).then(
            response =>
                dispatch({
                    type: LOAD_DELAYS_FULFILLED,
                    delays: response.delayDashboardResources,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_DELAYS_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadEMCs() {
    return function(dispatch) {
        dispatch({ type: LOAD_EMCS_PENDING });

        return get(`${BASE_URL}/emcs`).then(
            response =>
                dispatch({
                    type: LOAD_EMCS_FULFILLED,
                    emcs: response.emcResources,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_EMCS_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadEMCPlantCodes(emcCode) {
    return function(dispatch) {
        dispatch({ type: LOAD_EMCS_PLANT_CODES_PENDING });
        if(emcCode && emcCode !== 'undefined'){
            return get(`${BASE_URL_REPORTS}/getEmcPlantCode/${emcCode}`).then(
                response =>
                    dispatch({
                        type: LOAD_EMCS_PLANT_CODES_FULFILLED,
                        plants: response.emcResources,
                    }),
                error =>
                    handleApiError(error, dispatch, {
                        type: LOAD_EMCS_PLANT_CODES_REJECTED,
                        message: error.message,
                    })
            );
        }else{
            dispatch({
                type: LOAD_EMCS_PLANT_CODES_FULFILLED,
                plants: {},
            })
        }

    };
}

export function loadEMCDockCodes(emcPlantCode,emcCode) {
    return function(dispatch) {
        dispatch({ type: LOAD_EMCS_DOCK_CODES_PENDING });
        if(emcPlantCode && emcPlantCode !== 'undefined'){
            return get(`${BASE_URL_REPORTS}/getEMcDockCodes/${emcPlantCode}/${emcCode}`).then(
                response =>
                    dispatch({
                        type: LOAD_EMCS_DOCK_CODES_FULFILLED,
                        docks: response.emcResources,
                    }),
                error =>
                    handleApiError(error, dispatch, {
                        type: LOAD_EMCS_DOCK_CODES_REJECTED,
                        message: error.message,
                    })
            );
        }else{
            dispatch({
                type: LOAD_EMCS_DOCK_CODES_FULFILLED,
                docks: {},
            })
        }

    };
}

export function storeSearchTodoAbnormalities(searchTodoAbnormalities) {
    return function(dispatch) {
        dispatch({
            type: STORE_SEARCH_TODO_ABNORMALITIES,
            searchTodoAbnormalities,
        });
    };
}

export function storeSearchTodoRecoveryActions(searchTodoRecoveryActions) {
    return function(dispatch) {
        dispatch({
            type: STORE_SEARCH_TODO_RECOVERY_ACTIONS,
            searchTodoRecoveryActions,
        });
    };
}

export function storeSearchFollowUpRecoveryActions(searchFollowUpRecoveryActions) {
    return function(dispatch) {
        dispatch({
            type: STORE_SEARCH_FOLLOWUP_RECOVERY_ACTIONS,
            searchFollowUpRecoveryActions,
        });
    };
}

export function storeSearchDelays(searchDelays) {
    return function(dispatch) {
        dispatch({ type: STORE_SEARCH_DELAYS, searchDelays });
    };
}

export function storeSearchFollowUpAbnormalities(searchFollowUpAbnormalities) {
    return function(dispatch) {
        dispatch({
            type: STORE_SEARCH_FOLLOWUP_ABNORMALITIES,
            searchFollowUpAbnormalities,
        });
    };
}
